// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Content__Wrapper_2fE-O","ColLeft":"Content__ColLeft_3ySB1","ColRight":"Content__ColRight_39gn0","Block":"Content__Block_19_sf"};